import { Component } from "@angular/core";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { AppService } from "../../../app.service";
import { Router } from "@angular/router";
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { RequestResultSettingListItem } from "../../../shared/models/request-result-settings/request-result-setting-list-item";
import { RequestResultSettingsService } from "../../../shared/services/request-result-settings.service";
import { RequestResultSettingModal } from "../request-result-setting-modal/request-result-setting-modal";
import { DialogService } from "@progress/kendo-angular-dialog";

@Component({
	selector: 'request-result-settings-list-page',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss'],
})
export class RequestResultSettingsListPage extends ListPageBase<RequestResultSettingListItem> {

	constructor(
		appService: AppService,
		router: Router,
		protected dialogService: DialogService,
		protected lookupService: LookupService,
		protected dataService: RequestResultSettingsService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Настройки результатов заявки';
	}

	onListPageInit(): void {
		this.gridSettings.state.sort = [];
		this.gridSettings.state.take = 300;
		this.setGridSettings(this.gridSettings);
	}

	processListItems(items: RequestResultSettingListItem[]): void { }

	editSetting(item: RequestResultSettingListItem) {
		const dialogRef = this.dialogService.open({
			title: `Редактирование настройки №${item.requestResultSettingId}`,
			content: RequestResultSettingModal,
			width: '640px'
		});

		let dialog = <RequestResultSettingModal>dialogRef.content.instance;
		dialog.setting = { ...item };

		dialog.cancelEvent.subscribe(() => {
			dialogRef.close();
		});
		dialog.continueEvent.subscribe(() => {
			dialogRef.close();
			this.loadData();
		});
	}

	createNewSetting() {
		const dialogRef = this.dialogService.open({
			title: 'Создание новой настройки',
			content: RequestResultSettingModal,
			width: '640px'
		});

		let dialog = <RequestResultSettingModal>dialogRef.content.instance;

		dialog.cancelEvent.subscribe(() => {
			dialogRef.close();
		});
		dialog.continueEvent.subscribe(() => {
			dialogRef.close();
			this.loadData();
		});
	}

	removeHandler({ dataItem }): void {
		this.dataService.remove(dataItem.requestResultSettingId, null, 'Настройка удалена').subscribe(() => {
			this.loadData();
		});
	}
}
